import React, { Component } from 'react';
import { currency } from './../../../helpers/';

class PaymentItem extends Component {
    render() {
        return (
            <div className='row'>
                <div className="col-xs-9 col-md-10 col-lg-9 basket-item-description">
                    <h5 className="h5">{ this.props.name }</h5>
                </div>
                <div className="col-xs-3 col-md-2 col-lg-3 basket-item-price">{ currency.convert( this.props.price ) }</div>
            </div>
        );
    };
}

export default PaymentItem;



// WEBPACK FOOTER //
// src/client/components/common/transactions/PaymentItem.js